var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReturnBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4911 16.9709C33.4909 17.5711 33.0041 18.0576 32.4039 18.0576L1.53649 18.0569C1.09701 18.0569 0.700912 17.7922 0.532869 17.3862C0.364828 16.9801 0.457924 16.5128 0.768756 16.2019L9.17716 7.79354C9.60164 7.36906 10.2897 7.3689 10.714 7.7932C11.1383 8.21749 11.1381 8.90555 10.7137 9.33004L4.16015 15.8835L32.4049 15.8842C33.0051 15.8842 33.4914 16.3708 33.4911 16.9709Z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.707444 16.2635C1.09797 15.873 1.75054 15.8924 2.16501 16.3069L11.9778 26.1196C12.3923 26.5341 12.4117 27.1867 12.0212 27.5772C11.6306 27.9677 10.9781 27.9483 10.5636 27.5339L0.7508 17.7211C0.336331 17.3066 0.31692 16.654 0.707444 16.2635Z",
    fill: "#3A3A3A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnBack);
export default __webpack_public_path__ + "static/media/return-back.cd68e41bb05789f2437a24b9a8fffa22.svg";
export { ForwardRef as ReactComponent };